export const HEADER_MAP = {
  ctaButton: {
    title: 'Request a Quote',
    href: '/request-a-call',
  },
  utilityNav: [
    {
      icon: 'MapPin',
      linkItem: {
        title: 'Find a Showroom',
        href: '/showrooms',
      },
    },
    {
      icon: 'HelpCircle',
      linkItem: {
        title: 'Service Requests',
        href: '/service-requests',
      },
    },
    {
      icon: null,
      linkItem: {
        title: 'Make a Payment',
        href: 'https://payment.windownation.com',
      },
    },
    {
      icon: null,
      linkItem: {
        title: 'Service: (866) 217-9582',
        href: 'tel:18662179582',
      },
    },
    {
      icon: null,
      linkItem: {
        title: 'Sales: (877) 205-4494',
        href: 'tel:8772054494',
      },
    },
  ],
};
